import { render, staticRenderFns } from "./DealModal.vue?vue&type=template&id=0db885ac"
import script from "./DealModal.vue?vue&type=script&lang=js"
export * from "./DealModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports